import { SupersetApiService } from './service/SupersetApiService';

export const supersetApiService: SupersetApiService = new SupersetApiService();
